import * as React from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ApplicantsTable from "../components/Tables/ApplicantsTable";
import DemosTable from "../components/Tables/DemosTable";
import UsersTable from "../components/Tables/UsersTable";
import Alert from "@mui/material/Alert";
import MessageDisplay from "../components/global/MessageDisplay";
import Loading from "./Loading";

import { useLocation } from "react-router-dom";
import LineGraph from "../components/Charts/LineGraph";
import { API_URL } from "../../src/App";

export default function Dashboard() {
  const location = useLocation();

  const [messages, setMessages] = React.useState(null);
  const [logMes, setLogMes] = React.useState(null);
  const [err, setErr] = React.useState(null);
  const [alertOpen, setAlertOpen] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    axios.defaults.withCredentials = true 
    axios
      .get(`${API_URL}/get_active_messages`)
      .then((res) => {
        setMessages(res.data.messages);
        setIsLoading(false);
      })
      .catch((err) => setErr("alerts didn't load"));
  }, []);

  React.useEffect(() => {
    if (location.state) {
      axios
        .get(`${API_URL}/lastLogin`)
        .then((res) => setLogMes(res.data.lastLog))
        .catch((err) => setErr(" log in alert didn't load"));
    }
  }, []);


  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <>
      {isLoading && <Loading />}
      {isLoading === false && (
        <Grid id="i" container spacing={4}>
          {(messages || logMes) && (
            <Grid item xs={12}>
              {logMes && alertOpen && (
                <Alert
                  severity="success"
                  onClose={handleAlertClose}
                  sx={{ mt: 1, mb: 1 }}
                >
                  Welcome {logMes.username}. You last logged in at {logMes.time} 
                </Alert>
              )}
              {messages && <MessageDisplay messages={messages} />}
            </Grid>
          )}

          <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                height: 500,
              }}
            >
              <LineGraph />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                // height: 240,
              }}
            >
              <h4>Applicants</h4>
              <ApplicantsTable />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                // height: 240,
              }}
            >
              <h4>Demo Signups</h4>
              <DemosTable />
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Paper
              sx={{
                p: 2,
                display: "flex",
                flexDirection: "column",
                // height: 240,
              }}
            >
              <h4>Users close to expiry</h4>
              <UsersTable />
            </Paper>
          </Grid>

          </Grid>
      )}
    </>
  );
}
